// credit Hungry Ram

// var headers = document.querySelectorAll('#main-content h2');
//     headers.forEach(function (header) {
//     header.id = header.textContent.replace(/\s/g, '-').toLowerCase();
//     var tocContainer = document.getElementById('table-of-contents');
//     var anchor = document.createElement('a');
//     anchor.setAttribute('href', '#' + header.id);
//     anchor.innerText = header.textContent;
//     tocContainer.appendChild(anchor);
// });

(function() {
  const block = document.querySelector('[data-toc-block]');
  if (!block) return;

  const list = block.querySelector('.toc-block__list');
  const headings = document.querySelectorAll('#main-content h2');
  if (headings.length === 0) return;

  headings.forEach((heading, index) => {
    if (!heading.id) {
      heading.id = 'section-' + index;
    }
    const item = document.createElement('li');
    item.innerHTML = `<a href="#${heading.id}" data-toc-link="${heading.id}">${heading.textContent}</a>`;
    list.appendChild(item);
  });

  if (list.children.length > 0) {
    block.style.display = 'block';
  }

  

  const tocLinks = list.querySelectorAll('[data-toc-link]');

  function setActiveLink(id) {
    tocLinks.forEach(link => {
      link.classList.toggle('toc-block__link--active', link.dataset.tocLink === id);
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveLink(entry.target.id);
        }
      });
    },
    {
      rootMargin: '0px 0px -90% 0px',
      threshold: 0
    }
  );

  headings.forEach(heading => observer.observe(heading));
})();
